var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDragger = function SvgIconDragger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.191,
    height: 33.471,
    viewBox: "0 0 12.191 33.471",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1188.745 -413.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.869,6.093.256,1.484a.867.867,0,0,1,0-1.23.879.879,0,0,1,1.234,0L6.717,5.476a.87.87,0,0,1,.025,1.2L1.494,11.937A.871.871,0,0,1,.26,10.706Z",
    transform: "translate(1200.936 439.508) rotate(90)",
    fill: "#8d8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87,6.1.256,10.707a.867.867,0,0,0,0,1.23.879.879,0,0,0,1.234,0L6.717,6.715a.87.87,0,0,0,.025-1.2L1.494.254A.871.871,0,0,0,.26,1.485Z",
    transform: "translate(1188.745 419.979) rotate(-90)",
    fill: "#8d8585"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDragger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-dragger.483a540f.svg";
export { ForwardRef as ReactComponent };